export default __webpack_public_path__ + "static/media/total-jadwal.a302acd5.svg";